import './FieldLabel.css';

import { cn } from '##/utils/bem';

export const cnFieldLabel = cn('FieldLabel');
